import Enumerable from "linq";
import {
  FixedPhraseRootReference,
  FixedPhraseReference,
  IFixedPhraseContent,
  IFixedPhraseFolderContent,
  IFixedPhraseFolderRootContent,
} from "../../../domain/document";
import {
  Directory
} from "../../../domain/drawing";

export class FixedPhraseTranslator {
  toFixedPhraseTree(getToken: () => string, bean: IFixedPhraseFolderRootContent): FixedPhraseRootReference {
    if (!bean) {
      return new FixedPhraseRootReference(null, null, []);
    }
    return new FixedPhraseRootReference(
      bean.tableId,
      bean.templateId,
      this.toFixedPhraseDirectories(getToken, bean.folders)
    );
  }

  private toFixedPhraseDirectories(getToken: () => string, beans: IFixedPhraseFolderContent[]): Directory<number, FixedPhraseReference>[] {
    return Enumerable.from(beans)
      .select((b, i) => this.toFixedPhraseDirectory(getToken, b, i))
      .toArray();
  }

  private toFixedPhraseDirectory(getToken: () => string, bean: IFixedPhraseFolderContent, index: number): Directory<number, FixedPhraseReference> {
    return new Directory(
      index,
      bean.name,
      this.toFixedPhraseDirectories(getToken, bean.folders),
      this.toFixedPhrases(getToken, bean.phrase)
    );
  }

  private toFixedPhrases(getToken: () => string, beans: IFixedPhraseContent[]): FixedPhraseReference[] {
    return Enumerable.from(beans)
      .select(b => this.toFixedPhrase(getToken, b))
      .toArray();
  }

  private toFixedPhrase(getToken: () => string, bean: IFixedPhraseContent): FixedPhraseReference {
    return new FixedPhraseReference(
      bean.name,
      bean.text
    );
  }

  toFixedPhraseFolderRootBean(fixedPhrase: FixedPhraseRootReference): IFixedPhraseFolderRootContent {
    return {
      tableId: fixedPhrase.tableId,
      templateId: fixedPhrase.templateId,
      folders: this.toFixedPhraseFoldersBean(fixedPhrase.folders),
    };
  }

  private toFixedPhraseFoldersBean(folders: Directory<number, FixedPhraseReference>[]): IFixedPhraseFolderContent[] {
    return Enumerable.from(folders)
      .select(f => this.toFixedPhraseFolderBean(f))
      .toArray();
  }

  private toFixedPhraseFolderBean(folder: Directory<number, FixedPhraseReference>): IFixedPhraseFolderContent {
    return {
      name: folder.name,
      folders: this.toFixedPhraseFoldersBean(folder.nodes),
      phrase: this.toFixedPhrasesBean(folder.entities),
    };
  }

  private toFixedPhrasesBean(phrases: FixedPhraseReference[]): IFixedPhraseContent[] {
    return Enumerable.from(phrases)
      .select(p => this.toFixedPhraseBean(p))
      .toArray();
  }

  private toFixedPhraseBean(phrase: FixedPhraseReference): IFixedPhraseContent {
    return {
      name: phrase.name,
      text: phrase.text,
    };
  }
}
